import { createRouter, createWebHistory } from 'vue-router'

function load(component: string) {
  return () => import(`@/views/${component}.vue`)
}

export function setupRouter() {
  const routes = [
    {
      path: '/',
      name: 'Home',
      component: load('Home'),
    },
    {
      path: '/order/:organisationUid/:orderId',
      name: 'Order',
      component: load('Order'),
    },
    {
      path: '/orders/:organisationUid',
      name: 'Orders',
      component: load('Orders')
    },
    {
      path: '/p/:organisationUid',
      name: 'Pending',
      component: load('Pending')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]

  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  return router
}
